import { CLPUser } from "./clpuser.model";
import { GenericResponse } from "./genericResponse.model";

export interface EmailDetails {
  subject: string,
  message: string,
  toList: string,
  from: string
}

export interface emailDetails {
  subject: string,
  message: string,
  toList: string,
  from: string,
  bcc: string;
}

export interface EmailResponse extends GenericResponse {
  emailDetails: EmailDetails;
  contactId?: number;
  emailStatus: boolean;
  currentUser: CLPUser;
}

